import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ChevronRightIcon } from '@radix-ui/react-icons';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Header } from './project.page';
import { uiStore } from '../../core/stores/ui-store';
import { Task } from '../../app/entities';
import { TaskDetail } from '../../features/tasks/components/task-detail';

export const ProjectTaskRoute = observer(() => {
  const { taskId } = useParams();
  const task = Task.getOne(taskId) as Task;

  useEffect(() => {
    uiStore.currentLocation = 'project.tasks';

    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  if (!task) {
    return;
  }

  return (
    <>
      <Header>
        <Crumb>
          <Parent to="../">Tasks</Parent>
          <ChevronRightIcon />
          {task.title}
        </Crumb>
      </Header>

      <Scroller>
        <TaskDetail task={task} />
      </Scroller>
    </>
  );
});

const Scroller = styled.div`
  overflow-y: scroll;
  padding-top: 2.4rem;
`;

const Crumb = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
`;

const Parent = styled(Link)`
  color: #e3e4e7;

  &:hover {
    color: white;
  }
`;
